import { Create, useForm } from '@refinedev/antd';
import { useGo, useNotification } from '@refinedev/core';
import { useState } from 'react';

import FileData from '@/model/General/FileData';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';
import { RESOURCES } from '@/Resources';

import TicketForm from './TicketForm/TicketForm';

const TicketCreate = () => {
  const go = useGo();
  const [saving, setSaving] = useState(false);
  const { open } = useNotification();
  const { ticketRepository } = useRepositoriesContext();
  const { formProps, saveButtonProps } = useForm({
    redirect: false,
    successNotification: () => {
      return {
        message: ``,
        description: 'El ticket fue creado correctamente',
        type: 'success',
      };
    },
    errorNotification: () => {
      return {
        message: '',
        description: 'Ocurrió un error al crear el ticket',
        type: 'error',
      };
    },
    onMutationSuccess: response => {
      const id = response.data.id;

      if (fileList.length > 0 && id) {
        ticketRepository
          .filesManagement(fileList, id)
          .then(() => {
            setSaving(false);
            go({ to: { resource: RESOURCES.TICKETS, action: 'edit', id }, type: 'replace' });
          })
          .catch(error => {
            setSaving(false);
            open?.({
              message: '',
              description: 'Ocurrió un error al subir los archivos al ticket.',
              type: 'error',
            });
            console.error('Error uploading files:', error);
          });
      } else {
        if (id) {
          go({ to: { resource: RESOURCES.TICKETS, action: 'edit', id }, type: 'replace' });
        }
      }
    },
  });
  const [fileList, setFileList] = useState<FileData[]>([]);

  return (
    <Create
      saveButtonProps={{
        ...saveButtonProps,
        loading: saving,
        disabled: saving,
        onClick: e => {
          setSaving(true);
          saveButtonProps.onClick(e);
        },
      }}>
      <TicketForm formProps={formProps} fileList={fileList} setFileList={setFileList} />
    </Create>
  );
};

export default TicketCreate;
